import * as Oidc from "oidc-client-ts";

function getExport(name) {
  const value = Oidc[name];
  if (!value) {
    throw new Error(`oidc-client-ts export not found: ${name}`);
  }
  return value;
}

export const UserManager = getExport("UserManager");
export const WebStorageStateStore = getExport("WebStorageStateStore");

const fallbackLog = {
  NONE: 0,
  ERROR: 1,
  WARN: 2,
  INFO: 3,
  DEBUG: 4,
  setLogger: () => {},
  setLevel: () => {},
};

const logExportName = "Log";
export const Log = Oidc[logExportName] || fallbackLog;